export const getActionIconStyles = ({ isHighlighted, customStyles }) => ({
  color: ({ palette }) => (isHighlighted ? palette.text.highlight : palette.text.dark),

  '&:hover, &[aria-selected="true"]': {
    backgroundColor: ({ palette }) =>
      isHighlighted ? palette.background.hoverHighlight : palette.background.hoverDefault,
  },

  ...customStyles,
});
